import { useEffect, useState } from "react";
import harnessImage from "../../assets/images/harness.png";
import { useNavigate } from "react-router-dom";

export default function ProductRail({ title, items }) {
  const navigate = useNavigate();

  

const today = new Date();

const startDelivery = new Date(today);
startDelivery.setDate(today.getDate() + 3);

const endDelivery = new Date(today);
endDelivery.setDate(today.getDate() + 4);

const deliveryStart = startDelivery.toLocaleDateString("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric"
});

const deliveryEnd = endDelivery.toLocaleDateString("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric"
});

const fallbackDelivery = `${deliveryStart} – ${deliveryEnd}`;





  const styles = {

    section: {
      marginBottom: "50px"
    },

    title: {
      fontSize: "28px",
      marginBottom: "20px",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: "22px"
    },


 delivery: {
  fontSize: "15px",
  marginBottom: "4px"
},

fastest: {
  fontSize: "14px",
  color: "#565959",
  marginBottom: "8px"
},

   card: {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  padding: "18px",
  borderRadius: "22px",

position: "relative",
  
  background: "linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",

  border: "2px solid #ffffff",

  boxShadow:
    "0 0 30px rgba(120,170,255,0.18), \
     0 20px 50px rgba(0,0,0,0.10), \
     0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,1)",

  transition: "all 0.22s ease",

  cursor: "pointer",

  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
},
    imageWrap: {
      width: "100%",
      height: "180px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },

    image: {
      width: "90%",
      objectFit: "contain"
    },

    divider: {
      height: "1px",
      width: "100%",
      margin: "10px 0",
      background:
        "linear-gradient(to right, transparent, #e3e3e8, transparent)"
    },

    content: {
      textAlign: "center"
    },



stockBadge: {
  position: "absolute",
  top: "12px",
  left: "12px",

  padding: "4px 10px",

  fontSize: "12px",
  fontWeight: 600,

  borderRadius: "14px",

  background: "rgba(166, 186, 234, 0.12)",
  color: "#000000ff",

  border: "1px solid rgba(62,111,227,0.28)",

  display: "flex",
  alignItems: "center",
  gap: "6px",

  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui"
},


    itemTitle: {
      fontSize: "16px",
      color: "#1d1d1f",
      marginBottom: "6px",
      lineHeight: "22px"
    },

    priceRow: {
  display: "flex",
  justifyContent: "center",
  alignItems: "baseline",
  marginBottom: "14px"
},

    priceDollar: {
      fontSize: "16px"
    },

    priceMain: {
      fontSize: "26px",
      fontWeight: 500
    },

    priceCents: {
      fontSize: "16px"
    },

delivery: {
  fontSize: "15px",
  marginBottom: "6px",
  lineHeight: "20px"
},

fastest: {
  fontSize: "14px",
  color: "#565959",
  marginBottom: "14px",
  lineHeight: "20px"
},

   button: {
  marginTop: "10px",

  padding: "10px 18px",
  height: "42px",

  borderRadius: "30px",
  border: "none",

  background: "linear-gradient(180deg,#5a8efc,#1f57c8)",

  color: "white",
  fontWeight: 600,
  fontSize: "14px",

  cursor: "pointer",

  boxShadow:
    "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)",

  transition: "all 0.18s ease",

  width: "100%"
}
  };

  return (
    <section style={styles.section}>
      <h2 style={styles.title}>{title}</h2>

      <div style={styles.grid}>
        {items.map((item) => {

     const displayPrice =
  item.variants?.length
    ? Math.min(...item.variants.map(v => v.price))
    : item.price || 0;

const [main, cents] = Number(displayPrice)
  .toFixed(2)
  .split(".");

  

          return (
          <div
  key={item._id}
  style={styles.card}

 onClick={() => navigate(`/product/${item.listingId}`)}
  
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-8px)";
    e.currentTarget.style.boxShadow =
      "0 40px 90px rgba(0,0,0,0.14), 0 22px 55px rgba(62,111,227,0.20)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 0 30px rgba(120,170,255,0.18), \
       0 20px 50px rgba(0,0,0,0.10), \
       0 6px 18px rgba(0,0,0,0.06), \
       inset 0 1px 0 rgba(255,255,255,1)";
  }}
>

<div style={styles.stockBadge}>
  {(item.unitsAvailable ?? 1) > 0 ? "In Stock" : "Out of Stock"}
</div>

              {/* IMAGE */}
              <div style={styles.imageWrap}>
            
             <img
src={
  item.variants?.find(v => v.condition === "used")?.images?.[0] ||
  item.variants?.find(v => v.condition === "new")?.images?.[0] ||
  item.images?.[0] ||
  harnessImage
}
  style={styles.image}
/>
              </div>

              <div style={styles.divider}></div>

              {/* CONTENT */}
              <div style={styles.content}>

                <div style={styles.itemTitle}>
                  {item.title}
                </div>

              <div style={styles.priceRow}>
  <span style={styles.priceDollar}>$</span>
  <span style={styles.priceMain}>{main}</span>
  <span style={styles.priceCents}>{cents}</span>
</div>


<div style={styles.delivery}>
  FREE delivery <b>{item.delivery || fallbackDelivery}</b>
</div>

<div style={styles.fastest}>
  ⚡ Or fastest delivery <b>{item.fastest || deliveryStart}</b>
</div>


<button
  style={styles.button}
  onClick={(e) => {
  e.stopPropagation();
 navigate(`/product/${item.listingId}`);
}}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow =
      "0 18px 38px rgba(62,111,227,0.45), 0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)";
  }}
>
  Buy Now
</button>


</div>

            </div>
          );
        })}
      </div>
    </section>
  );
}